"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.unsetMatchedUser = exports.unsetLoadingState = exports.unsetGraphqlData = exports.unsetCheckingUser = exports.setUserAvailable = exports.setMatchedUser = exports.setLoadingState = exports.setHasCheckedUser = exports.setGraphqlData = exports.setFormValid = exports.setFormInvalid = exports.setCheckingUser = exports.runQuery = exports.resetState = exports.initialState = exports.handleFormSubmit = exports["default"] = exports.checkUser = exports.changeAllFields = void 0;
var _reduxActions = require("redux-actions");
var _cccisdLaravelNexus = require("cccisd-laravel-nexus");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _cccisdApollo = require("cccisd-apollo");
var _queryVariablesHelper = _interopRequireDefault(require("../helpers/queryVariablesHelper.js"));
var _submitHandler = _interopRequireDefault(require("../components/FormWrapper/submitHandler"));
var _validationHandler = _interopRequireDefault(require("../components/FormWrapper/validationHandler"));
var _getEmptyFieldValue = _interopRequireDefault(require("../helpers/getEmptyFieldValue.js"));
var _templateObject, _handleActions;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var checkUserDelay = 1000;

// Initial state
var initialState = exports.initialState = {
  loading: true,
  checkingUser: false,
  userAvailable: true,
  formValid: true,
  graphqlData: {},
  matchedUser: {},
  hasCheckedUser: false
};

// Actions
var SET_LOADING_STATE = 'formWrapper/SET_LOADING_STATE';
var UNSET_LOADING_STATE = 'formWrapper/UNSET_LOADING_STATE';
var SET_CHECKING_USER = 'formWrapper/SET_CHECKING_USER';
var UNSET_CHECKING_USER = 'formWrapper/UNSET_CHECKING_USER';
var SET_USER_AVAILABLE = 'formWrapper/SET_USER_AVAILABLE';
var SET_FORM_VALID = 'formWrapper/SET_FORM_VALID';
var SET_FORM_INVALID = 'formWrapper/SET_FORM_INVALID';
var SET_GRAPHQL_DATA = 'formWrapper/SET_GRAPHQL_DATA';
var UNSET_GRAPHQL_DATA = 'formWrapper/UNSET_GRAPHQL_DATA';
var SET_MATCHED_USER = 'formWrapper/SET_MATCHED_USER';
var UNSET_MATCHED_USER = 'formWrapper/UNSET_MATCHED_USER';
var RESET_STATE = 'formWrapper/RESET_STATE';
var HAS_CHECKED_USER = 'formWrapper/HAS_CHECKED_USER';

// Action Creators
var setLoadingState = exports.setLoadingState = (0, _reduxActions.createAction)(SET_LOADING_STATE);
var unsetLoadingState = exports.unsetLoadingState = (0, _reduxActions.createAction)(UNSET_LOADING_STATE);
var setCheckingUser = exports.setCheckingUser = (0, _reduxActions.createAction)(SET_CHECKING_USER);
var unsetCheckingUser = exports.unsetCheckingUser = (0, _reduxActions.createAction)(UNSET_CHECKING_USER);
var setUserAvailable = exports.setUserAvailable = (0, _reduxActions.createAction)(SET_USER_AVAILABLE);
var setFormValid = exports.setFormValid = (0, _reduxActions.createAction)(SET_FORM_VALID);
var setFormInvalid = exports.setFormInvalid = (0, _reduxActions.createAction)(SET_FORM_INVALID);
var setGraphqlData = exports.setGraphqlData = (0, _reduxActions.createAction)(SET_GRAPHQL_DATA);
var unsetGraphqlData = exports.unsetGraphqlData = (0, _reduxActions.createAction)(UNSET_GRAPHQL_DATA);
var setMatchedUser = exports.setMatchedUser = (0, _reduxActions.createAction)(SET_MATCHED_USER);
var unsetMatchedUser = exports.unsetMatchedUser = (0, _reduxActions.createAction)(UNSET_MATCHED_USER);
var resetState = exports.resetState = (0, _reduxActions.createAction)(RESET_STATE);
var setHasCheckedUser = exports.setHasCheckedUser = (0, _reduxActions.createAction)(HAS_CHECKED_USER);
var checkUser = exports.checkUser = function checkUser(requestData) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var userCheckResponse;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            dispatch(setCheckingUser());
            _context.n = 1;
            return (0, _cccisdLaravelNexus.UserCheck)(requestData, checkUserDelay);
          case 1:
            userCheckResponse = _context.v;
            dispatch(setUserAvailable(userCheckResponse.available));
            if (!getState().appdefs.formWrapper.hasCheckedUser) {
              dispatch(setHasCheckedUser());
            }
            if (userCheckResponse.user && !(0, _isEmpty2["default"])(userCheckResponse.user)) {
              dispatch(setMatchedUser(userCheckResponse.user));
            } else {
              dispatch(unsetMatchedUser());
            }
            dispatch(unsetCheckingUser());
            return _context.a(2, userCheckResponse);
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var validate = exports.validate = function validate(values, formProps) {
  return function (dispatch, getState) {
    return (0, _validationHandler["default"])(values, formProps);
  };
};
var changeAllFields = exports.changeAllFields = function changeAllFields(event, fieldProps) {
  return function (dispatch, getState) {
    var field = fieldProps.field,
      fieldTypes = fieldProps.fieldTypes,
      operation = fieldProps.operation,
      requiredByFields = fieldProps.requiredByFields;
    var reduxState = getState();
    var reduxForm = reduxState.form && reduxState.form.DynamicForm;
    if (reduxForm && operation && fieldTypes) {
      Object.keys(fieldTypes).forEach(function (fieldName) {
        var f = fieldTypes[fieldName];
        if (f.graphql && f.graphql[operation] && f.graphql[operation].filterQuery && f.graphql[operation].requiredVariables) {
          var shouldClear = false;
          f.graphql[operation].requiredVariables.forEach(function (rv) {
            if (rv.reduxField !== undefined && rv.reduxField === field.name) {
              shouldClear = true;
            }
          });
          if (shouldClear && reduxForm[fieldName]) {
            reduxForm[fieldName].value = (0, _getEmptyFieldValue["default"])(f);
          }
        }
      });
    }

    // First, update this form field's value
    field.onChange(event);
    // If this field value is required by other fields, run onChange on each
    if (!(0, _isEmpty2["default"])(requiredByFields)) {
      Object.keys(requiredByFields).forEach(function (rf) {
        requiredByFields[rf].onChange(event);
      });
    }
  };
};
var runQuery = exports.runQuery = function runQuery() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var graphqlQuery = arguments.length > 1 ? arguments[1] : undefined;
  var queryVariables = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var variables, response;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch(setLoadingState());
            variables = {};
            if (graphqlQuery) {
              variables = (0, _queryVariablesHelper["default"])(queryVariables, data);
            }
            _context2.n = 1;
            return _cccisdApollo.client.query({
              query: (0, _cccisdApollo.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                ", "\n            "])), graphqlQuery),
              variables: variables,
              fetchPolicy: 'network-only'
            });
          case 1:
            response = _context2.v;
            dispatch(setGraphqlData(response.data));
            dispatch(unsetLoadingState());
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var handleFormSubmit = exports.handleFormSubmit = function handleFormSubmit(_ref3) {
  var row = _ref3.row,
    values = _ref3.values,
    routes = _ref3.routes,
    fieldTypes = _ref3.fieldTypes,
    hasMatchedUser = _ref3.hasMatchedUser;
  return function (dispatch, getState) {
    return (0, _submitHandler["default"])({
      row: row,
      values: values,
      routes: routes,
      fieldTypes: fieldTypes,
      hasMatchedUser: hasMatchedUser
    });
  };
};

// Reducers
var _default = exports["default"] = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_CHECKING_USER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    checkingUser: true
  });
}), UNSET_CHECKING_USER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    checkingUser: false
  });
}), SET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), UNSET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), SET_FORM_VALID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    formValid: true
  });
}), SET_FORM_INVALID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    formValid: false
  });
}), SET_USER_AVAILABLE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    userAvailable: action.payload
  });
}), SET_GRAPHQL_DATA, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    graphqlData: action.payload
  });
}), UNSET_GRAPHQL_DATA, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    graphqlData: {}
  });
}), SET_MATCHED_USER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    matchedUser: action.payload
  });
}), _defineProperty(_defineProperty(_defineProperty(_handleActions, UNSET_MATCHED_USER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    matchedUser: {}
  });
}), HAS_CHECKED_USER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    hasCheckedUser: true
  });
}), RESET_STATE, function (state, action) {
  return {
    loading: true,
    checkingUser: false,
    userAvailable: true,
    formValid: true,
    graphqlData: {},
    matchedUser: {}
  };
})), initialState);